"use client"

import React, { FC } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import { JobDetailsFooterInvitationBanner } from "./JobDetailsFooterInvitationBanner"
import { JobDetailsFooterAppliedBanner } from "./JobDetailsFooterAppliedBanner"
import { JobPostingStatus } from "@/gql/graphql"
import { JobDetailsFooterClosedBanner } from "./JobsDetailFooterClosedBanner"
import { JobsDetailFooterApplicationsClosed } from "./JobsDetailFooterApplicationsClosed"
import { JobDetailsFooterViewedBanner } from "./JobDetailsFooterViewedBanner"
import { JobDetailsFooterChatStartedBanner } from "./JobDetailsFooterChatStartedBanner"

const JobsDetailAuthenticatedFooterBannerJobApplicationFragment = graphql(`
  fragment JobsDetailAuthenticatedFooterBannerJobApplication on JobApplication {
    __typename
    id
    clientHasInteractedWith
    chat {
      id
    }
    ...JobDetailsFooterChatStartedBanner
    ...JobDetailsFooterAppliedBanner
    ...JobDetailsFooterViewedBanner
  }
`)

const JobsDetailAuthenticatedFooterBannerJobInvitationFragment = graphql(`
  fragment JobsDetailAuthenticatedFooterBannerJobInvitation on JobInvitation {
    __typename
    id
    ...JobDetailsFooterInvitationBanner
  }
`)

const JobsDetailAuthenticatedFooterBannerJobPostingFragment = graphql(`
  fragment JobsDetailAuthenticatedFooterBannerJobPosting on JobPosting {
    __typename
    id
    status
    acceptingApplications
    ...JobDetailsFooterClosedBanner
    ...JobDetailFooterApplicationsClosed
  }
`)

interface Props {
  jobApplication: FragmentType<typeof JobsDetailAuthenticatedFooterBannerJobApplicationFragment> | undefined | null
  jobInvitation: FragmentType<typeof JobsDetailAuthenticatedFooterBannerJobInvitationFragment> | undefined | null
  jobPosting: FragmentType<typeof JobsDetailAuthenticatedFooterBannerJobPostingFragment> | undefined | null
  isCreativeJobPosting: boolean
}

/* 
This logic probably needs revised.
Should we show multiple tags in some situations?
It's a bit confusing as we dont have a way to mark someone as hired.
Should it still
*/
export const JobsDetailAuthenticatedFooterBanner: FC<Props> = ({ isCreativeJobPosting, ...props }) => {
  const jobApplication = useFragment(JobsDetailAuthenticatedFooterBannerJobApplicationFragment, props.jobApplication)
  const jobInvitation = useFragment(JobsDetailAuthenticatedFooterBannerJobInvitationFragment, props.jobInvitation)
  const jobPosting = useFragment(JobsDetailAuthenticatedFooterBannerJobPostingFragment, props.jobPosting)

  return (
    <div className="">
      {jobPosting?.status === JobPostingStatus.Closed ? (
        <div className="mb-4">
          <JobDetailsFooterClosedBanner jobPosting={jobPosting} />
        </div>
      ) : !jobPosting?.acceptingApplications ? (
        <div className="mb-4">
          <JobsDetailFooterApplicationsClosed jobPosting={jobPosting} />
        </div>
      ) : jobApplication?.chat?.id ? (
        <div className="mb-4">
          <JobDetailsFooterChatStartedBanner jobApplication={jobApplication} />
        </div>
      ) : jobApplication?.clientHasInteractedWith ? (
        <div className="mb-4">
          <JobDetailsFooterViewedBanner jobApplication={jobApplication} />
        </div>
      ) : jobApplication?.id ? (
        <div className="mb-4">
          <JobDetailsFooterAppliedBanner jobApplication={jobApplication} />
        </div>
      ) : jobInvitation?.id ? (
        <div className="mb-4">
          <JobDetailsFooterInvitationBanner jobInvitation={jobInvitation} isCreativeJobPosting={isCreativeJobPosting} />
        </div>
      ) : null}
    </div>
  )
}
